import { render, staticRenderFns } from "./tilda_general_tab.vue?vue&type=template&id=448f39cf&scoped=true&"
import script from "./tilda_general_tab.vue?vue&type=script&lang=js&"
export * from "./tilda_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f39cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('448f39cf')) {
      api.createRecord('448f39cf', component.options)
    } else {
      api.reload('448f39cf', component.options)
    }
    module.hot.accept("./tilda_general_tab.vue?vue&type=template&id=448f39cf&scoped=true&", function () {
      api.rerender('448f39cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/tilda/location/tabs/tilda_general_tab.vue"
export default component.exports